/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from 'App'
import { AuthContextProvider, MaterialUIControllerProvider } from 'context'
import ReactGA from 'react-ga'
import Favicon from 'react-favicon'
import Spinner from 'components/Spinner'

import * as Sentry from '@sentry/react'

// Material Dashboard 2 React Context Provider

Sentry.init({
  dsn: 'https://1de985a269d66f0ef0466b9e471e8a5a@o4506806512058368.ingest.sentry.io/4506806522609664',
  enabled: process.env.REACT_APP_DEVELOPMENT !== 'true',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/grile\.info\/api/,
    /^https:\/\/med\.grile\.info\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

ReactGA.initialize('G-4XZJP27TJC')
ReactDOM.render(
  <>
    <Favicon
      url={`${process.env.REACT_APP_URL}home/logos/${process.env.REACT_APP_TYPE}/favicon.ico`}
    />
    <BrowserRouter>
      <GoogleOAuthProvider clientId="800439524839-fp78q7jlvhrdimge4rejpostjib442tf.apps.googleusercontent.com">
        <AuthContextProvider>
          <MaterialUIControllerProvider>
            <App />
            <div id="modal-root" />
            <div
              id="tutorial-overlay"
              style={{ display: 'none' }}
              className="fixed top-0 left-0 w-[100vw] h-[100vh] bg-[rgba(0,0,0,0.85)] z-[1000] align-center justify-center"
            >
              <Spinner />
            </div>
          </MaterialUIControllerProvider>
        </AuthContextProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </>,
  document.getElementById('root'),
)
